import { render } from "./materielForm.vue?vue&type=template&id=622b150e"
import script from "./materielForm.vue?vue&type=script&lang=js"
export * from "./materielForm.vue?vue&type=script&lang=js"

import "./materielForm.vue?vue&type=style&index=0&id=622b150e&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__